import React from "react";
import { Field, TextInput, Textarea, Honeypot, SubmitRow, Confirmation } from "./Form";
import { useFormState, useSubmit, firstErrorFocus } from "../hooks/useForm";
import { requiredError, emailError } from "../lib/workEmail";

const INITIAL = { name: "", organisation: "", email: "", message: "", hp: "" };

export default function ContactForm() {
  const { values, errors, setErrors, update } = useFormState(INITIAL);
  const { pending, done, serverError, submit } = useSubmit("contact");

  const onSubmit = async (e) => {
    e.preventDefault();
    const next = {
      name: requiredError(values.name),
      organisation: requiredError(values.organisation),
      email: emailError(values.email),
      message: requiredError(values.message),
    };
    setErrors(next);
    if (Object.values(next).some(Boolean)) return firstErrorFocus(next);
    await submit({
      name: values.name.trim(),
      organisation: values.organisation.trim(),
      email: values.email.trim(),
      message: values.message.trim(),
      hp: values.hp,
    });
  };

  if (done) {
    return <Confirmation testId="contact-confirmation">Thank you. We reply within three working days.</Confirmation>;
  }

  return (
    <form onSubmit={onSubmit} className="form" noValidate data-testid="contact-form">
      <div className="form-row">
        <Field label="Name" htmlFor="name" error={errors.name}>
          <TextInput id="name" name="name" value={values.name} onChange={update("name")} autoComplete="name" invalid={!!errors.name} testId="contact-name" />
        </Field>
        <Field label="Organisation" htmlFor="organisation" error={errors.organisation}>
          <TextInput id="organisation" name="organisation" value={values.organisation} onChange={update("organisation")} autoComplete="organization" invalid={!!errors.organisation} testId="contact-organisation" />
        </Field>
      </div>
      <Field label="Work email" htmlFor="email" error={errors.email}>
        <TextInput id="email" name="email" type="email" value={values.email} onChange={update("email")} autoComplete="email" invalid={!!errors.email} testId="contact-email" />
      </Field>
      <Field label="Message" htmlFor="message" error={errors.message}>
        <Textarea id="message" name="message" rows={6} value={values.message} onChange={update("message")} maxLength={5000} invalid={!!errors.message} testId="contact-message" />
      </Field>
      <Honeypot value={values.hp} onChange={update("hp")} />
      <SubmitRow pending={pending} label="Send" testId="contact-submit" error={serverError} />
    </form>
  );
}
